module.exports = __webpack_public_path__ + "media/icons/user-9f54d72c.svg";